import React from "react";
import FooterButtons from "../../../../../components/Classroom/FooterButtons";

const LiveClassFooter = ({
  classId,
  classroomId,
  permissions,
  createdBy,
  userInformation,
  navigate,
}) => {
  // Only show footer buttons when not in classroom details page
  if (classId === "") {
    return null;
  }

  return (
    <div className="col-12">
      <FooterButtons
        canelHandler={() => {
          navigate("/myClassrooms");
        }}
        saveHandler={() => {
          navigate(`/classrooms/${classroomId}/pricing`);
        }}
        disabled={
          !permissions.edit &&
          !(permissions.edit_own && createdBy === userInformation?._id)
        }
      />
    </div>
  );
};

export default LiveClassFooter;
